module.exports = __webpack_public_path__ + "static/media/militia_shield.ad7393e7.png";